import React, { useContext, useEffect } from "react";
import FilterPopup from "../FilterPopup";
import SelectableList from "../components/SelectableList";
import { type DocumentProgressFilterType, type DocumentProgressFilterOption, getOption, DocumentProgressOptions, initialDocumentProgressFilter } from "./FilterTypes/DocumentProgressFilterType";
import { FilterContext } from "../FilterContext";

export const DefaultDocumentProgressFilter: server.dto.DocumentLifeCycleFilterOptions = "unknown";

const DocumentProgressFilter = () => {
  const title = RESX.Document.Progress;

  const { register, getValue, setInitialValue, setValue } = useContext(FilterContext);
  const reset = (): DocumentProgressFilterType => ({
    option: getOption(DefaultDocumentProgressFilter)
  });
  register("documentProgress", {
    getTitle: () => title,
    renderSelection: (value) => <>{value.option.label}</>,
    hasValue: (value) => value.option.value !== DefaultDocumentProgressFilter,
    reset,
    areEqual: (a, b) => a.option.value === b.option.value
  });
  useEffect(() => {
    setInitialValue("documentProgress", reset());
  }, []);

  const [popupOpen, setPopupOpen] = React.useState<boolean>(false);
  const [selectedOption, setSelectedOption] = React.useState(initialDocumentProgressFilter.option);

  const onChange = (option: DocumentProgressFilterOption) => {
    if (selectedOption?.value === option.value) {
      setValue("documentProgress", reset());
      setSelectedOption(undefined);
    } else {
      setSelectedOption(option);
      setValue("documentProgress", { option });
    }
    onPopupClose();
  };

  const onPopupClose = () => {
    setPopupOpen(false);
  };

  const onPopupOpen = () => {
    setSelectedOption(getValue("documentProgress").option);
    setPopupOpen(true);
  };

  return <div>
    <FilterPopup
      filterButtonLabel={title}
      width={272}
      content={<div>
        <SelectableList
          noSearch
          items={DocumentProgressOptions}
          selectedItems={selectedOption ? [selectedOption] : []}
          onItemToggled={onChange}
          getId={opt => opt.value}
          getName={opt => opt.label}
        />
      </div>}

      open={popupOpen}
      onClose={onPopupClose}
      onOpen={onPopupOpen}
    />
  </div>;
};

export default DocumentProgressFilter;